import { apiRequest, setApiAuthToken } from './client.js';
import type { AdminRole, AdminPermission } from '@hisob/types';

export interface AdminLoginRequest {
  email: string;
  secret: string;
}

export interface AdminLoginResponse {
  access_token: string;
  admin: {
    id: string;
    email: string;
    name: string;
    role: AdminRole;
    permissions: AdminPermission[];
  };
}

export async function loginAdmin(credentials: AdminLoginRequest): Promise<AdminLoginResponse> {
  const response = await apiRequest<AdminLoginResponse>('/api/v1/admin/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });
  setApiAuthToken(response.access_token);
  return response;
}

export async function getAdminProfile(): Promise<AdminLoginResponse['admin']> {
  return apiRequest<AdminLoginResponse['admin']>('/api/v1/admin/auth/me');
}

